export default Object.freeze({
  NOTAPPLIED: "NOTAPPLIED",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
});
